import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from "@nkr/store/index";
import { IProductCenter, IBaseResponse, IProductCenterForList } from "@nkr/models/index";
import { AxiosError } from 'axios';

export interface IProductCenterListResponse {
    data: {
        success: boolean,
        message: string,
        results: IProductCenter[]
    }
}

export interface IProductCenterResponse {
    data: {
        success: boolean,
        message: string,
        results: IProductCenter
    }
}

export interface IProductCenterForListResponse {
    data: {
        success: boolean,
        message: string,
        results: IProductCenterForList[]
    }
}

export interface ISaveProductCenterResponse {
    data: {
        success: boolean,
        message: string,
        results: IProductCenter
    }
}

export const ActionCreatorsProductCenter = {
    getProductCentersByCenter: (centerId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IProductCenterListResponse> => {
        let options = {
            url: `${__API__}/crm/${centerId}/products`
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IProductCenterListResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    getProductCenter: (centerId: number, productId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IProductCenterResponse> => {
        let options = {
            url: `${__API__}/crm/${centerId}/product/${productId}`
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IProductCenterResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    getProductCenters: () => (dispatch: Dispatch<IApplicationState>): Promise<IProductCenterForListResponse> => {
        let options = {
            url: `${__API__}/crm/product-center`
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IProductCenterForListResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },

    saveProductCenter: (centerId: number, productId: number, nextSteps: string, targetDate: string, closeDate: string, closedBy: number) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/crm/product-center`,
            data: {
                centerId,
                productId,
                nextSteps,
                targetDate,
                closeDate,
                closedBy
            }
        };

        return dispatch(AuthActionCreators.apiPost(options))
            .then((response: ISaveProductCenterResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    saveProductCenters: (requests: { centerId: number, productId: number, nextSteps: string, targetDate: string, closeDate: string }[]) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/crm/product-centers`,
            data: requests
        };

        return dispatch(AuthActionCreators.apiPost(options))
            .then((response: ISaveProductCenterResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    deleteProductCenter: (centerId: number, productId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/crm/${centerId}/product/${productId}`
        };

        return dispatch(AuthActionCreators.apiDelete(options))
            .then((response: ISaveProductCenterResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
}
